import { NextPageContext } from 'next';
import Head from 'next/head';
import { generateSimpleStructuredData } from 'common/utils';
import { generateCookieList } from 'common/utils/trackingTag';
import AboutPageLayout from 'components/v2/layouts/about-page-layout';
import ArticleInterview from 'components/v2/molecules/article-interview';
import { parse } from 'cookie';
import data from 'data/article/creator/interview-kuu-chan';

const InterviewKuuChanPage = () => {
  const metadata = data.metadata;

  return (
    <>
      <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={metadata.url} />
        <meta property="og:title" content={metadata.title} />
        <meta property="og:description" content={metadata.description} />
        <meta property="og:image" content={metadata.image} key="og:image" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content={metadata.title} />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={metadata.url} />
        <meta property="twitter:title" content={metadata.title} />
        <meta property="twitter:description" content={metadata.description} />
        <meta property="twitter:image" content={metadata.image} />

        <meta name="keywords" content={metadata.keywords} />
        <link rel="canonical" href={metadata.url} />
        {/* JSON-LD Structured Data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: generateSimpleStructuredData(metadata),
          }}
        />
      </Head>
      <AboutPageLayout>
        <ArticleInterview article={data} />
      </AboutPageLayout>
    </>
  );
};

export const getServerSideProps = (context: NextPageContext) => {
  const cookiesList = generateCookieList(
    context.query,
    parse(context.req?.headers?.cookie || ''),
  );
  if (cookiesList.length > 0) {
    context.res.setHeader('Set-Cookie', cookiesList);
  }
  return {
    props: {},
  };
};

export default InterviewKuuChanPage;
